import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/services/dailyCut/store/dailyCutSlice/initialState.ts'
import { DailyCutCashOut } from '@/modules/services/dailyCut/types/DailyCutCashOut.ts'

const dailyCutSlice = createSlice({
  name: 'dailyCut',
  initialState,
  reducers: {
    setDailyCutFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    setOpenProcesarPagoModal: (state, action: PayloadAction<boolean>) => {
      state.isProcesarPagoModalOpen = action.payload
    },
    setSelectedRows: (state, action: PayloadAction<DailyCutCashOut[]>) => {
      state.selectedRows = action.payload
    },
    reset: () => initialState
  }
})

export const dailyCutActions = dailyCutSlice.actions
export const { reducer: dailyCutReducer } = dailyCutSlice
